import { render, staticRenderFns } from "./EditFunderProgramList.vue?vue&type=template&id=a96c14c8"
import script from "./EditFunderProgramList.vue?vue&type=script&lang=js"
export * from "./EditFunderProgramList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports